export default __webpack_public_path__ + "066f2605b2c05228bc53ef4d6dcfedb5.jpg";